/**
 * BookingAPIs.js contains methods need to request information during booking process
 * @see all booking mixins
 */

import globalMoment from "../GlobalMoment";

export default {
    mixins: [globalMoment],

    data() {
        return {
            searchAssignments: [],
            assignmentIntervals: null,
            apiCancelledLessons: [],
            apiGroupEvents: [],
            apiLoading: false,
            timeout: [],
            assignmentsLoading: false,
        };
    },
    methods: {
        $_apis_getAssignments(simStudentView = false) {
            console.log(
                this.form.duration,
                this.form.instrument,
                this.form.templateEvent
            );
            if (!this.form.duration) return;
            if (!this.form.instrument && !this.form.templateEvent) return;
            if (this.form.templateEvent?.registration_event) return;
            this.assignmentsLoading = true;
            this.$_setApiTimer();
            axios
                .get("/api/assignments/search", {
                    params: {
                        user: this.form.teacher?.id,
                        timezone: this.$page.props.guest?.timezone ?? null,
                        staff: Number(this.$page.props.staffView),
                        type: this.form.type.name,
                        location: this.form.location?.id,
                        //? this.form.location.id
                        //: this.$page.props.auth.user.selected_location.id,
                        duration: this.form.duration,
                        instrument_id: this.form.instrument?.id,
                        simStudentView: Number(simStudentView),
                        inStudio: Number(!this.form.online),
                        repeating: Number(this.form.repeating),
                        age_range_id:
                            this.form.ageRange?.id ||
                            this.form.student?.age_range_id,
                        skill_level_id: this.form.skillLevel?.id ?? null,
                    },
                })
                .then((resp) => {
                    this.searchAssignments = resp.data;
                    this.assignmentsLoading = false;
                    this.$_clearApiTimer();
                    if (!resp.data.length) return;
                    //if (!this.form.teacher) return;
                    this.onlineOnly = Object.values(resp.data).every(
                        (e) => e.availability.online_only
                    );
                })
                .catch((error) => {
                    console.log(error);
                    this.$_clearApiTimer();
                    this.showAxiosAlert(error.response?.data?.message);
                });
        },
        async $_apis_getAssignmentOpenings(simStudentView = false) {
            this.$_setApiTimer();
            if (!this.form.startDate) return;

            let assignments = await this.searchAssignments.filter((e) => {
                return (
                    this.globalMomentYMD(e.starts_at) ==
                        this.globalMomentYMD(this.form.startDate) &&
                    (e.availability?.online_only ? this.form.online : true)
                );
            });

            if (!assignments.length) {
                this.$_clearApiTimer();
                return;
            }

            return axios
                .get("/api/assignments/assignment-intervals", {
                    params: {
                        user: this.form.teacher?.id ?? null,
                        type: this.form.type.name,
                        duration: this.form.duration,
                        assignment_ids: assignments.length
                            ? assignments.map((e) => e.id)
                            : [],
                        repeating: Number(this.form.repeating),
                        simStudentView: Number(simStudentView),
                        timezone: this.$page.props.guest?.timezone ?? null,
                    },
                })
                .then((resp) => {
                    this.assignmentIntervals = resp.data;
                    this.$_clearApiTimer();
                })
                .catch((error) => {
                    this.assignmentIntervals = [];
                    this.$_clearApiTimer();
                    this.showAxiosAlert(error.response?.data?.message);
                });
        },
        $_apis_getCancelledLessons(isReschedule, student) {
            if (!isReschedule || !student) {
                this.$_controls_blurInput();
                return;
            }

            this.$_setApiTimer();
            return axios
                .get("/api/lessons/cancelled-lessons", {
                    params: {
                        student_id: student.id,
                        group_event_id: this.form.templateEvent?.id,
                        limitTypes: 0, //Number(this.$page.props.staffView),
                        //starts_at: this.$_data_lessonStart
                    },
                })
                .then((resp) => {
                    this.apiCancelledLessons = resp.data;
                    this.$_clearApiTimer();
                })
                .catch((error) => {
                    console.log(error);
                    this.$_clearApiTimer();
                    this.showAxiosAlert(error.response?.data?.message);
                });
        },
        /**
         * Used when booking from calendar.
         * Check if teacher is already teaching at this time
         * @returns {object} lessons conflicting with selected time
         */
        $_apis_getTeacherConflicts() {
            if (!this.form.teacher) return;
            if (!this.form.duration) return;
            if (!this.$_data_lessonStart) return;
            if (!this.$_data_lessonEnd) return;
            this.$_setApiTimer();

            return axios
                .get("/api/lessons/teacher-conflicts", {
                    params: {
                        user_id: this.form.teacher?.id,
                        start: this.$_data_lessonStart.format("lll"),
                        end: this.$_data_lessonEnd.format("lll"),
                        originalEventId: this.event?.id,
                    },
                })
                .then((resp) => {
                    this.$_clearApiTimer();
                    if (!resp.data) return;
                    let auth = this.$page.props.auth.user;
                    let teacher = this.form.teacher;
                    let authIsTeacher = auth.id == teacher.id;
                    let getName = authIsTeacher
                        ? "You are"
                        : teacher.name + " is";
                    this.showTeacherConflictAlert(
                        `${getName} already teaching on ${
                            this.form.startDate
                        } at ${
                            this.form.startTime
                        }. Please select another time${
                            authIsTeacher ? "." : " or teacher."
                        }`
                    );
                })
                .catch((error) => {
                    this.$_clearApiTimer();
                    this.showAxiosAlert(error.response?.data?.message);
                });
        },
        $_apis_getApiGroupEvents(type) {
            this.$_setApiTimer();
            return axios
                .get("/api/lessons/group-events", {
                    params: {
                        type: type,
                    },
                })
                .then((resp) => {
                    this.apiGroupEvents = resp.data;
                    this.$_clearApiTimer();
                })
                .catch((error) => {
                    this.showAxiosAlert(error.message);
                    this.$_clearApiTimer();
                });
        },
        $_apis_updateGuestSession() {
            return;
            if (!this.bookingSource.isGuestSession) return;
            this.$_setApiTimer();
            return axios
                .put("/get-started/update", {
                    location_id: this.form.location?.id,
                    instrument_id: this.form.instrument?.id,
                    online: this.form.online,
                })
                .then((resp) => {
                    this.$_clearApiTimer();
                })
                .catch((error) => {
                    this.$page.props.errors.apiExpired =
                        this.showGuestSessionExpired(
                            error.response?.data?.message
                        );
                    this.$_clearApiTimer();
                });
        },
        /*$_apis_getApiUpcomingGroupEvents(eventId) {
            if (!eventId) return;
            this.$_setApiTimer();
            axios
                .get("/api/lessons/upcoming-group-events", {
                    params: {
                        eventId: eventId,
                        student_id: this.form.student.id,
                        nearMe: this.$page.props.auth.user.selected_location
                            .emma_account_id,
                    },
                })
                .then((resp) => {
                    this.apiUpcomingGroupEvents = resp.data;
                    this.$_clearApiTimer();
                })
                .catch((error) => {
                    this.showAxiosAlert(error.message);
                    this.$_clearApiTimer();
                });
        },*/
        $_setApiTimer() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.apiLoading = true;
                this.$emit("apiLoading", this.apiLoading);
            }, 0);
        },
        $_clearApiTimer() {
            clearTimeout(this.timeout);
            this.apiLoading = false;
            this.$emit("apiLoading", this.apiLoading);
        },
    },
};
